<h2 mat-dialog-title>Change Action State</h2>

<mat-dialog-content>

  <!-- Current State -->
  <div style="margin-bottom:16px;padding:8px;background:#f5f5f5;border-radius:4px;">
    <strong>Current State:</strong>
    <span style="margin-left:8px;padding:4px 8px;background:#e0e0e0;border-radius:4px;">
      {{ currentState }}
    </span>
  </div>

  <form [formGroup]="form">

    <!-- New State -->
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>New State</mat-label>

      <mat-select
        formControlName="state"
        (selectionChange)="onStateChange($event.value)">

        <mat-option
          *ngFor="let item of actionStatusList"
          [value]="item.lookupvalue || item.value">

          {{ item.lookupvalue || item.value }}

        </mat-option>

      </mat-select>

      <!-- FIXED: Use shouldShowError method instead of just touched -->
      <mat-error *ngIf="shouldShowError('state')">
        State is required
      </mat-error>

    </mat-form-field>

    <!-- Reason Section -->
    <div *ngIf="showReasonField">
      <label class="textColour page-title">
        Reason for {{ selectedState }}
      </label>

      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Select Reason</mat-label>

        <mat-select
          formControlName="reasonText"
          (selectionChange)="onReasonChange($event.value)">

          <mat-option
            *ngFor="let reason of getReasonList()"
            [value]="reason.lookupvalue || reason.value">

            {{ reason.lookupvalue || reason.value }}

          </mat-option>

        </mat-select>

        <!-- FIXED: Use shouldShowError method -->
        <mat-error *ngIf="shouldShowError('reasonText')">
          Reason is required
        </mat-error>

      </mat-form-field>

      <!-- Other Reason -->
      <mat-form-field
        *ngIf="showOtherReasonField"
        appearance="outline"
        class="full-width">

        <mat-label>Other Reason</mat-label>

        <textarea
          matInput
          rows="3"
          formControlName="otherReasonText">
        </textarea>

        <!-- FIXED: Use shouldShowError method -->
        <mat-error *ngIf="shouldShowError('otherReasonText')">
          Other reason required
        </mat-error>

      </mat-form-field>

    </div>

    <!-- Outcome Section -->
    <div *ngIf="showOutcomeField">
      <label class="textColour page-title">
        Action Outcome
      </label>

      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Select Outcome</mat-label>

        <mat-select
          formControlName="actionOutcome"
          (selectionChange)="onOutcomeChange($event.value)">

          <mat-option
            *ngFor="let outcome of actionOutcomeList"
            [value]="outcome.lookupvalue || outcome.value">

            {{ outcome.lookupvalue || outcome.value }}

          </mat-option>

        </mat-select>

        <!-- FIXED: Use shouldShowError method -->
        <mat-error *ngIf="shouldShowError('actionOutcome')">
          Outcome is required
        </mat-error>

      </mat-form-field>

      <!-- Other Outcome -->
      <mat-form-field
        *ngIf="showOtherOutcomeField"
        appearance="outline"
        class="full-width">

        <mat-label>Other Outcome</mat-label>

        <textarea
          matInput
          rows="3"
          formControlName="otherOutcomeText">
        </textarea>

        <!-- FIXED: Use shouldShowError method -->
        <mat-error *ngIf="shouldShowError('otherOutcomeText')">
          Other outcome required
        </mat-error>

      </mat-form-field>

    </div>

  </form>

</mat-dialog-content>

<mat-dialog-actions align="end" style="padding: 1rem 0; gap: 0.5rem;">
  <app-common-button
      label="Cancel"
      title="Cancel"
      [buttonId]="1111"
      width="110px"
      [critical]="false"
      variant="cancel"
      (clicked)="close()">
  </app-common-button>
  
  <app-common-button
      label="Confirm"
      title="Confirm state Change"
      [buttonId]="1111"
      width="110px"
      [critical]="false"
      (clicked)="submit()">
  </app-common-button>
</mat-dialog-actions>